import { RootState } from 'store';

import { RegisterDemoUseErrors } from './Types';

export const selectUnitId = ({ unitOverview: { unitId } }: RootState): number =>
	unitId;

export const selectProductIndividualCommentsCount =
	(id: number) =>
	({ unitOverview: { productIndividuals } }: RootState): number =>
		productIndividuals[id]?.commentsCount;

export const selectWarrantyErrors = (
	state: RootState
): RegisterDemoUseErrors | null => state.productInOperation.warrantyErrors;
